import { OrderAddStore } from './types'

const DEFAULT_POINT = {
  selectedOption: null,
  daDataSearchAddressValue: '',
  isAddressCourierDelivery: false,
  isAddressTerminalDelivery: false,
  isCourier: undefined,
  terminals: null,
  selectedTerminal: null,
  comment: '',
  errorAddress: ''
}
export const ORDER_ADD_INITIAL_STATE = {
  customerId: '',
  fromPoint: DEFAULT_POINT,
  toPoint: DEFAULT_POINT,
  isDadataDisable: false
} as OrderAddStore
